import React from 'react';
export function AnimatedWaves() {
  return <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" style={{
    minHeight: '100%'
  }} data-id="element-18">
      {/* Wave group 1 — Hero area */}
      <svg className="absolute w-[120%] -left-[10%] animate-wave1" style={{
      top: '5%'
    }} viewBox="0 0 1600 200" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-19">
        <path d="M-50,140 C200,60 500,180 800,100 C1100,20 1300,160 1650,80" stroke="rgba(201,168,76,0.18)" strokeWidth="2" data-id="element-20" />
        <path d="M-50,160 C250,80 550,190 850,120 C1150,50 1350,170 1650,100" stroke="rgba(201,168,76,0.12)" strokeWidth="1.5" data-id="element-21" />
      </svg>

      {/* Wave group 2 — Below hero */}
      <svg className="absolute w-[130%] -left-[15%] animate-wave2" style={{
      top: '18%'
    }} viewBox="0 0 1600 200" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-22">
        <path d="M-50,100 C300,180 600,30 900,120 C1200,210 1400,60 1650,130" stroke="rgba(201,168,76,0.16)" strokeWidth="1.8" data-id="element-23" />
      </svg>

      {/* Wave group 3 — Mid page */}
      <svg className="absolute w-[125%] -left-[12%] animate-wave3" style={{
      top: '32%'
    }} viewBox="0 0 1600 200" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-24">
        <path d="M-50,150 C200,50 450,180 750,80 C1050,0 1300,170 1650,90" stroke="rgba(255,255,255,0.1)" strokeWidth="2" data-id="element-25" />
        <path d="M-50,120 C300,200 600,60 900,150 C1200,240 1400,80 1650,160" stroke="rgba(201,168,76,0.12)" strokeWidth="1.5" data-id="element-26" />
      </svg>

      {/* Wave group 4 — Lower mid */}
      <svg className="absolute w-[120%] -left-[10%] animate-wave1" style={{
      top: '48%'
    }} viewBox="0 0 1600 200" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-27">
        <path d="M-50,80 C250,170 550,20 850,110 C1150,200 1350,50 1650,140" stroke="rgba(201,168,76,0.15)" strokeWidth="1.8" data-id="element-28" />
      </svg>

      {/* Wave group 5 — Lower area */}
      <svg className="absolute w-[130%] -left-[15%] animate-wave2" style={{
      top: '62%'
    }} viewBox="0 0 1600 200" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-29">
        <path d="M-50,130 C200,40 500,190 800,90 C1100,10 1350,180 1650,70" stroke="rgba(255,255,255,0.08)" strokeWidth="2" data-id="element-30" />
        <path d="M-50,160 C350,70 650,200 950,100 C1250,20 1400,170 1650,110" stroke="rgba(201,168,76,0.12)" strokeWidth="1.5" data-id="element-31" />
      </svg>

      {/* Wave group 6 — Near bottom */}
      <svg className="absolute w-[125%] -left-[12%] animate-wave3" style={{
      top: '76%'
    }} viewBox="0 0 1600 200" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-32">
        <path d="M-50,100 C300,190 600,40 900,130 C1200,220 1400,70 1650,150" stroke="rgba(201,168,76,0.16)" strokeWidth="1.8" data-id="element-33" />
      </svg>

      {/* Wave group 7 — Bottom */}
      <svg className="absolute w-[120%] -left-[10%] animate-wave1" style={{
      top: '90%'
    }} viewBox="0 0 1600 200" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-34">
        <path d="M-50,140 C250,50 550,180 850,80 C1150,0 1350,160 1650,100" stroke="rgba(255,255,255,0.08)" strokeWidth="2" data-id="element-35" />
        <path d="M-50,110 C200,190 500,50 800,140 C1100,230 1350,70 1650,150" stroke="rgba(201,168,76,0.1)" strokeWidth="1.5" data-id="element-36" />
      </svg>
    </div>;
}